import { ThemeProfile } from './types';

export const nightOpsProfile: ThemeProfile = {
  pageBackground: 'transparent',
  hud: {
    overlayOpacity: 0.4,
    dotsOpacity: 0.15,
    showAnimatedGrid: false,
    showGlobalScanline: true,
  },
  cards: {
    background: '#0c1e2f',
    border: 'rgba(0, 212, 255, 0.35)',
    shadow: '0 18px 32px rgba(1, 12, 20, 0.75)',
  },
};
